<div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin: auto; height: '50vh';">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>